module.exports = vendors_en_761bb360a30fd2707e83;